export default __webpack_public_path__ + "static/media/rocket_anim_106.36c8616d.png";